<template>
    <div class="row mt-5">
        <div class="col-8 offset-2 div-terms">
            <legend>{{ translate.titleTermsUse }}</legend>
            <div class="col-12 box-terms">
                <span v-html="exemp"></span>
            </div>
            <div class="col-12">
                <div class="row ">
                    <div class="col-lg-6 col-12 accept">
                        <input type="checkbox" name="acept" id="acept" v-model="acept" />
                        <label for="checkbox">{{ translate.aceitlabel }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script lang="ts">
import { defineComponent } from 'vue'
import tradutor from 'tradutors/assine'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import api from '../../api'

export default defineComponent({
    name: 'FormUser',
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        }
    },
    created(){
        this.getTerms()
    },
    watch: {
        'locale': function () {
            this.getTerms()
        }
    },
    data() {
        return {
            acept: false,
            exemp: `Terms and Conditions

contact@lorem-ipsum.info`
        }
    },
    methods: {
        getTerms() {
            api.get(`v1/subscribe/getTerms?language=${this.locale}`).then(({ data: { terms: { description } } }) => {
                this.exemp = description
            })
        }
    }
})
</script>
  
<style scoped lang="css">
legend {
    color: #b40909;
    font-weight: 700;
    font-family: 'Exo-2';
    margin-bottom: 30px;
    margin-left: 10px;
}

.d-w-btn {
    color: #fff;
    width: 100%;
    padding: 17px 0px;
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    font-family: 'Exo-2';
}

label {
    height: 23px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 23px;

}

input[type=checkbox] {
    position: relative;
    cursor: pointer;
    margin-inline: 15px;
    width: 20px;
    height: 20px;
}

input[type=checkbox]:before {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    top: -3px;
    left: -3px;
    background-color: #000;
}

input[type=checkbox]:checked:before {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    top: -3px;
    left: -3px;
    background-color: #000;
}

input[type=checkbox]:checked:after {
    content: "";
    display: block;
    width: 9px;
    height: 15px;
    border: solid red;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 2px;
    left: 6px;
}

.box-terms {
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    height: 400px;
    overflow-y: scroll;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-terms {
        width: 95%;
        margin-left: 10px;
    }

    legend {
        font-size: 18px;
    }

    .accept {
        margin-bottom: 30px;
    }

    .d-w-btn {
        width: 70%;
    }
}
</style>
  